import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: theme.spacing(1),
    // marginBottom: theme.spacing(2),
  },
  search: {
    position: 'relative',
    width: '100%',
    display: 'flex',
  },
  searchIcon: {
    width: theme.spacing(9),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'grey',
  },
  searchIconSidebar: {
    width: theme.spacing(5),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  inputInput: {
    paddingTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(8),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      // width: 120,
      // '&:focus': {
      //   width: 200,
      // },
    },
  },
  inputInputSidebar: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(6),
    transition: theme.transitions.create('width'),
    width: '100%',
  },
  sortContainer: {
    marginLeft: theme.spacing(1),
    padding: theme.spacing(1),
    height: 36,
  },
  sortForm: {
    marginTop: -4,
  },
  select: {
    width: (props) => (props.isMobile ? 75 : 150),
  },
  clearIcon: {
    width: '2em',
    height: '2em',
  },
}));
